import { FooterPortal, NavbarPortal } from "components";
import loginImage from "../../assets/images/portal/login.webp";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { PulseLoader } from "react-spinners";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { API_URL_agent, API_URL_login } from "constants/api";
// import { loginUser } from "redux/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { isAuth } from "actions";
import { loginUser } from "actions/auth";
import { encryptStringLocalStorage } from "utils/encryptStringLocalStorage";
import { AuthContext } from "context/AuthContext";
import { encryptArrayLocalStorage } from "utils/encryptArrayLocalStorage";

const Login = () => {
  const { loginUserResult, loginUserLoading } = useSelector(
    (state) => state.auth
  );
  const { setDatauser, datauser } = useContext(AuthContext);
  const [loginLoading, setLoginLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Email harus diisi"),
      password: Yup.string().required("Password harus diisi"),
    }),
    onSubmit: (values) => {
      const log = loginUser(dispatch, values);
      formik.resetForm({
        values: {
          email: values.email,
          password: "",
        },
      });
    },
  });
  const [visiblePassword, setVisiblePassword] = useState(false);

  const loadDatauser = () => {
    axios({
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      url: API_URL_agent + isAuth().user_id + "/",
    })
      .then((response) => {
        setDatauser(response.data);
        encryptStringLocalStorage("selorxnz", response.data.role);
        encryptArrayLocalStorage(
          "noissimrepedc",
          response.data.group_permissions
        );
      })
      .catch((error) => {
        console.log(error);
        setDatauser("");
      });
  };

  useEffect(() => {
    if (loginUserResult !== false) {
      loadDatauser();
    }
  }, [loginUserResult]);

  useEffect(() => {
    if (datauser !== "") {
      setDatauser(datauser);
    }
  }, [datauser]);

  useEffect(() => {
    if (datauser !== "") {
      setLoginLoading(true);
      setTimeout(() => {
        setLoginLoading(false);
        const permissionViewMenuAgent = datauser.group_permissions.includes(
          "access_menu_agent"
        );
        const permissionViewMenuAdmin = datauser.group_permissions.includes(
          "access_menu_admin"
        );
        if (permissionViewMenuAgent && permissionViewMenuAdmin) {
          window.location.href = "/dashboard/agent";
        } else if (permissionViewMenuAgent && !permissionViewMenuAdmin) {
          window.location.href = "/dashboard/agent";
        } else if (!permissionViewMenuAgent && permissionViewMenuAdmin) {
          window.location.href = "/administrator/dashboard/admin";
        } else {
          window.location.href = "/";
        }
      }, 1000);
    }
  }, [datauser]);

  return (
    <div className="overflow-hidden">
      <div className="flex flex-col min-h-screen overflow-hidden text-gray-700">
        <main className="flex flex-grow overflow-hidden">
          <div className="w-full ">
            <NavbarPortal current={"Beranda"} isGradient={true} />

            <div className="relative grid grid-cols-12 h-[79.9vh]">
              <div className="col-span-full absolute h-full z-0 md:static md:col-span-6 bg-sky-950">
                {/* <img src={loginImage} className="gambar-login w-full" /> */}
                <img
                  src={loginImage}
                  className="h-full w-full object-contain md:object-cover"
                />
              </div>
              <div className="col-span-full absolute h-full w-full z-10 md:static md:col-span-6">
                <div className="px-5 py-5 md:py-8 padding-topbottom md:px-14 w-full h-full">
                  <div className="border-2 shadow-2xl rounded-lg px-5 md:py-8 py-5 md:px-5 bg-white mt-10 md:mt-0 ">
                    <p className="text-2xl md:text-5xl font-bold mb-4">
                      Login Admin
                    </p>

                    <form onSubmit={formik.handleSubmit}>
                      <div className="relative mb-4">
                        <label className="font-bold">Email</label>
                        <input
                          id="email"
                          type="text"
                          name="email"
                          placeholder="Masukkan Email"
                          onChange={formik.handleChange}
                          value={formik.values.email}
                          className="w-full px-1 py-2 border-2 mt-1 border-gray-300  focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                        />
                        {formik.touched.email && formik.errors.email && (
                          <div className="text-red-500">
                            {formik.errors.email}
                          </div>
                        )}
                      </div>
                      <div className="relative mb-4">
                        <label className="font-bold mb-2">Password</label>
                        <input
                          id="password"
                          name="password"
                          type={visiblePassword ? "text" : "password"}
                          placeholder="Masukkan Password"
                          onChange={formik.handleChange}
                          value={formik.values.password}
                          className="w-full px-1 py-2 border-2 mt-1 border-gray-300  focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                        />
                        <div
                          className="absolute text-gray-400 top-[36px] right-2 text-2xl cursor-pointer"
                          onClick={() => setVisiblePassword(!visiblePassword)}
                        >
                          {visiblePassword ? <FaEye /> : <FaEyeSlash />}
                        </div>
                        {formik.touched.password && formik.errors.password && (
                          <div className="text-red-500">
                            {formik.errors.password}
                          </div>
                        )}
                      </div>

                      <button
                        type="submit"
                        disabled={loginLoading}
                        className="bg-gradient-to-b from-sky-600 to-sky-900 text-white w-full py-2 hover:bg-gradient-to-br text-xl"
                      >
                        {loginLoading ? (
                          <PulseLoader color="#fff" size={11} />
                        ) : (
                          "Login"
                        )}
                      </button>

                      <div className="text-center mt-4 text-blue-500 hover:text-blue-700">
                        <Link to={`/forgot-password`}>Forgot My Password</Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <FooterPortal />
      </div>
    </div>
  );
};

export default Login;
